import React from 'react';
import PropTypes from 'prop-types';
import { flightsAndAirlines as s } from 'core/i18n';

const AirlinesTableForA11y = ({ airlines }) => {
  return (
    <div className="visually-hidden">
      <table>
        <caption>{s.airlines}</caption>
        <thead>
          <tr>
            <th>{s.airline}</th>
            <th>{s.terminal}</th>
            <th>{s.code}</th>
            <th>{s.checkIn}</th>
            <th>{s.checkInOptions}</th>
            <th>{s.checkInTime}</th>
            <th>{s.preCheckIn}</th>
            <th>{s.delayedBaggage}</th>
            <th>{s.foundPropertyInformation}</th>
            <th>{s.website}</th>
          </tr>
        </thead>
        <tbody>
          {airlines.map(
            ({
              name,
              terminal,
              code,
              checkInArea,
              checkInOptions,
              checkInTime,
              advanceCheckIn,
              delayedBaggage,
              lostNfound,
              website,
            }) => {
              return (
                <tr key={code}>
                  <td>{name}</td>
                  <td>{terminal}</td>
                  <td>{code}</td>
                  <td>{checkInArea}</td>
                  <td>{checkInOptions}</td>
                  <td dangerouslySetInnerHTML={{ __html: checkInTime }} />
                  <td dangerouslySetInnerHTML={{ __html: advanceCheckIn }} />
                  <td dangerouslySetInnerHTML={{ __html: delayedBaggage }} />
                  <td dangerouslySetInnerHTML={{ __html: lostNfound }} />
                  <td dangerouslySetInnerHTML={{ __html: website }} />
                </tr>
              );
            }
          )}
        </tbody>
      </table>
    </div>
  );
};

AirlinesTableForA11y.propTypes = {
  airlines: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      terminal: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      checkInArea: PropTypes.string.isRequired,
      checkInOptions: PropTypes.string.isRequired,
      checkInTime: PropTypes.string.isRequired,
      advanceCheckIn: PropTypes.string.isRequired,
      delayedBaggage: PropTypes.string.isRequired,
      lostNfound: PropTypes.string.isRequired,
      website: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default AirlinesTableForA11y;
